<template>
  <div class="flow-flex-center jFlow">
    <div class="wrap">

      <div class="bullet-center fl-right">
        <router-link
          to="/flows">
          <i class="fa fa-times"/>
        </router-link>
      </div>

      <div class="bullet-center">
        <h2>Update Flow</h2>
      </div>

      <div class="bullet-center">
        <div class="flow-new__bullet-top">
          <i class="fa fa-square"/>
        </div>
      </div>

      <div class="bullet-center">
        <div class="line-empty"/>
      </div>

      <!-- Flow of Approver -->
      <div
        v-for="(approver, index) in flow"
        :key="index"
        class="approver-order">
        <div
          v-if="index > 0"
          class="bullet-center">
          <div class="line-empty half-line"/>
        </div>
        <div class="header-flow">
          <div class="header-actions">
            <i
              class="fa fa-edit"
              @click="editFlow(index)"/>
            <i
              class="fa fa-times"
              @click="removeFlow(index)"/>
          </div>
          Approver {{ approver.order }}
        </div>
        <div class="content-flow">
          {{ approver.organigram_name ? approver.organigram_name.name : "" }} <br>
          {{ // eslint-disable-next-line max-len
            approver.organigram_member_name ? approver.organigram_member_name : (approver.organigram_name ?
              // eslint-disable-next-line max-len
              (approver.organigram_name.user ? `${approver.organigram_name.user.profile.first_name} ${approver.organigram_name.user.profile.last_name}` : "")
          : "") }}
        </div>
      </div>

      <div class="bullet-center">
        <div class="line-empty half-line"/>
      </div>

      <div class="bullet-center add-approver-flow">
        <b-btn
          class="btn blue outline"
          @click="openAddApproverForm">
          ADD APPROVER
        </b-btn>

        <!-- Modal appearance for add approver -->
        <b-modal
          ref="flowApprover"
          class="mod-form"
          centered
          no-close-on-backdrop
          no-close-on-esc>

          <!-- close button modal -->
          <div
            v-if="!edit_approver.status"
            class="close-modal-flow"
            @click="closeAddApprover">
            <i class="fa fa-times"/>
          </div>

          <!-- close for edit -->
          <div
            v-else
            class="close-modal-flow"
            @click="closeEdit">
            <i class="fa fa-times"/>
          </div>

          <!-- title modal -->
          <div
            v-if="edit_approver.status"
            class="title-flow">
            <i class="fa fa-square"/>
            Edit Approver
          </div>
          <div
            v-else
            class="title-flow">
            <i class="fa fa-square"/>
            Add Approver
          </div>

          <!-- Select division -->
          <b-form-radio-group v-model="selected">
            <b-form-radio
              value="true"
              name="Radios"
              class="jFormGroup">
              Select Division*
            </b-form-radio>
          </b-form-radio-group>
          <b-form-group :class="{'error-input' : $v.v_addApprover.organigram_id.$error}">
            <j-single-select
              v-model="v_addApprover.organigram_id"
              :disabled="selected !== 'true'"
              :is-async="true"
              :load-options="loadOptionsDivision"
              value-format="object"
              label="name"
              placeholder="All Division"/>
          </b-form-group>
          <b-form-group
            v-if="selected === 'true'"
            :class="{'error-input' : $v.v_addApprover.organigram_name.$error}">
            <label>Select Position*</label>
            <j-single-select
              v-model="v_addApprover.organigram_name"
              :is-async="true"
              :load-options="loadOptionsPositionByDivision"
              :disabled="!v_addApprover.organigram_id"
              value-format="object"
              class="v-singleselect"
              label="name"
              placeholder="Select Position"/>
          </b-form-group>

          <!-- add division -->
          <div v-if="!edit_approver.status">
            <b-form-radio-group
              v-model="selected">
              <b-form-radio
                value="false"
                name="Radios"
                class="jFormGroup">
                Add Division*
              </b-form-radio>
            </b-form-radio-group>
            <b-form-group
              :class="{'error-input' : $v.v_addDivision.division.$error}">
              <j-input
                :disabled="selected === 'true'"
                v-model="v_addDivision.division"
                :max-length="255"
                placeholder="Add New Division"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.division_code.$error}">
              <label>Division Code*</label>
              <j-input
                v-model="v_addDivision.division_code"
                :max-length="255"
                placeholder="Division Code"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.title.$error}">
              <label>Add Position*</label>
              <j-input
                v-model="v_addDivision.title"
                :max-length="255"
                placeholder="Add Position"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.title_code.$error}">
              <label>Position ID*</label>
              <j-input
                v-model="v_addDivision.title_code"
                :max-length="255"
                placeholder="Position ID"/>
            </b-form-group>
            <b-form-group
              v-if="selected !== 'true'"
              :class="{'error-input' : $v.v_addDivision.user.$error}">
              <label>Select User*</label>
              <j-single-select
                v-model="v_addDivision.user"
                :is-async="true"
                :load-options="loadOptions"
                value-format="object"
                class="v-singleselect"
                placeholder="Select User"
                label="email"/>
            </b-form-group>
          </div>

          <div class="wrap-button-flow">
            <b-button
              v-if="edit_approver.status"
              class="btn blue"
              @click="saveEditFlow">
              EDIT APPROVER
            </b-button>
            <b-button
              v-else
              class="btn blue"
              @click="setApprover">
              SET APPROVER
            </b-button>
            <b-button
              v-if="!edit_approver.status"
              class="btn blue outline"
              @click="clearSelectedApprover">
              CLEAR
            </b-button>
          </div>

        </b-modal>
      </div>

      <!-- button for create Flow -->
      <div
        class="bullet-center">
        <b-button
          v-if="flow[0]"
          class="btn blue"
          @click="$refs.saveFlow.show()">Update</b-button>
      </div>

      <!-- Modal appearance for Save Flow -->
      <b-modal
        ref="saveFlow"
        class="mod-form save-flow-approver"
        no-close-on-backdrop
        no-close-on-esc
        centered>

        <!-- close button modal -->
        <div
          class="close-modal-flow"
          @click="$refs.saveFlow.hide()">
          <i class="fa fa-times"/>
        </div>

        <!-- title modal -->
        <div class="title-flow">
          <i class="fa fa-square"/>
          Update Flow
        </div>

        <b-form-group :class="{'error-input' : $v.v_saveFlow.name.$error}">
          <label>Flow Name*</label>
          <j-input
            v-model="v_saveFlow.name"
            :max-length="50"
            placeholder="ex: Flow-01"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.v_saveFlow.type.$error}">
          <label>Flow Type*</label>
          <j-single-select
            v-model="v_saveFlow.type"
            :options="flow_type"
            :placeholder="'Select Type'"
            value-format="object"
            label="name"/>
        </b-form-group>

        <div class="wrap-button-flow">
          <b-button
            class="btn blue"
            @click="saveFlow">
            Update
          </b-button>
        </div>

      </b-modal>

      <!-- <b-button @click="filterIsDelete">Click</b-button> -->

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import apiUser from '@/services/jApiUser';
import jMixPaginationOption from '@/mixins/components/global/jMixPaginationOption';

const flowTypes = [
  {
    id: 1,
    type: 1,
    name: 'Order',
    minimum_action: 0,
  },
  {
    id: 2,
    type: 2,
    name: 'No Order',
    minimum_action: 0,
  },
  {
    id: 3,
    type: 3,
    name: 'Minimum 1',
    minimum_action: 1,
  },
  {
    id: 4,
    type: 3,
    name: 'Minimum 2',
    minimum_action: 2,
  },
  {
    id: 5,
    type: 3,
    name: 'Minimum 3',
    minimum_action: 3,
  },
];

export default {
  mixins: [
    jMixPaginationOption,
  ],
  data() {
    return {
      edit_approver: {
        status: false,
        current_edit: null,
      },
      selected: 'true',
      flow_type: flowTypes,
      v_addApprover: {
        organigram_id: null,
        organigram_name: null,
        order: 1,
      },
      v_addDivision: {
        division: null,
        division_code: null,
        title: null,
        title_code: null,
        user: null,
      },
      v_saveFlow: {
        name: null,
        type: null,
      },
      oldEditData: [],
      flow: [],
    };
  },
  validations: {
    v_addApprover: {
      organigram_id: { required },
      organigram_name: { required },
    },
    v_addDivision: {
      division: { required },
      division_code: { required },
      title: { required },
      title_code: { required },
      user: { required },
    },
    v_saveFlow: {
      name: { required },
      type: { required },
    },
  },
  computed: {
    ...mapState('jStoreFlows', ['users_list', 'divisions_list', 'by_divisions_list', 'new_division', 'detail_flow']),
    add_approver() {
      return {
        organigram_id: this.v_addApprover.organigram_id,
        order: this.v_addApprover.order,
        organigram_name: this.v_addApprover.organigram_name,
      };
    },
    save_approver_flow() {
      return this.flow.map(prop => ({
        organigram_id: prop.organigram_name.id,
        order: prop.order,
      }));
    },
    edit_approver_flow() {
      const indexing = this.edit_approver.current_edit;
      return {
        organigram_id: this.flow[indexing].organigram_id,
        order: this.flow[indexing].order,
        organigram_name: this.flow[indexing].organigram_name,
      };
    },
    save_flow() {
      const IsDeleteFlow = this.filterIsDelete();
      return {
        id: this.detail_flow.id,
        name: this.v_saveFlow.name,
        type: this.v_saveFlow.type.type,
        minimum_action: this.v_saveFlow.type.minimum_action,
        members: IsDeleteFlow,
      };
    },
    add_Division() {
      return {
        division: {
          name: this.v_addDivision.division,
          code: this.v_addDivision.division_code,
          description: '',
        },
        organigram: {
          user_company_id: this.v_addDivision.user.id,
          name: this.v_addDivision.title,
          description: '',
          code: this.v_addDivision.title_code,
          divisions: [],
        },
      };
    },
  },
  watch: {
    detail_flow(newVal) {
      const dataVal = newVal.members.map((flow) => {
        const detail = {
          id: flow.id,
          order: flow.order,
          organigram_name: flow.organigram,
          flow_id: flow.flow_id,
          is_delete: false,
          organigram_id: { id: flow.organigram_id },
          organigram_member_name: flow.organigram_member_name ? flow.organigram_member_name : '',
        };
        return detail;
      });
      this.flow = dataVal;

      const flowType = this.flow_type.find(f => f.type === newVal.type &&
      f.minimum_action === newVal.minimum_action);
      const flowName = {
        name: newVal.name,
        type: flowType || null,
        // type: {
        //   minimum_action: newVal.minimum_action,
        //   name: newVal.type === 3 ?
        //     `${newVal.type_name} ${newVal.minimum_action}` : newVal.type_name,
        //   type: newVal.type,
        // },
      };
      this.v_saveFlow = flowName;
    },

    flow() {
      this.flow.forEach((data, index) => {
        const indexorder = index + 1;
        if (data.order !== indexorder) {
          this.flow[index].order = indexorder;
        }
      });
    },
    selected() {
      this.clearSelectedApprover();
      this.$v.v_addApprover.$reset();
      this.$v.v_addDivision.$reset();
    },
    // watch division and get detail of title each division
    /* eslint func-names: ["error", "never"] */
    'v_addApprover.organigram_id': function () {
      if (this.v_addApprover.organigram_id) {
        // const reqData = {
        //   division_id: newData.id,
        // };
        // this.getListByDivisions(reqData);
      }
    },
    by_divisions_list() {
      if (this.v_addApprover.organigram_name) {
        if (this.v_addApprover.organigram_name.id !== this.by_divisions_list[0].id) {
          this.v_addApprover.organigram_name = '';
        }
      }
    },
    new_division(val) {
      const addApprover = {
        organigram_id: val.divisions[0],
        order: this.v_addApprover.order,
        organigram_name: val,
      };
      this.flow.push(addApprover);
      this.v_addApprover.order += 1;
      this.toggleLoading();
      this.getListDivisions();
      this.selected = 'true';
    },
  },
  created() {
    // this.getListDivisions();
    this.getDetailFlow({ id: Number(this.$route.params.id) });
  },
  methods: {
    ...mapActions('jStoreFlows', ['getListDivisions', 'getListByDivisions', 'createDivisionInFlow', 'createNewFlow', 'getDetailFlow', 'updateFlow', 'getDetailPosition']),
    ...mapActions('jStoreNotificationScreen', ['toggleLoading']),

    // loadOptionsDivision({ action, searchQuery, callback }) {
    //   if (action === ASYNC_SEARCH) {
    //     const reqData = {
    //       pagination: {
    //         limit: 50,
    //         page: 1,
    //         column: '',
    //         ascending: true,
    //         query: searchQuery,
    //       },
    //     };
    //     this.getListDivisions({ reqData, callback });
    //   }
    // },

    filterIsDelete() {
      const finalObj = [];
      this.detail_flow.members.forEach((k) => {
        let dataExist = false;
        for (let i = 0; i < this.save_approver_flow.length; i += 1) {
          if (k.id === this.flow[i].id) {
            dataExist = true;
            finalObj.push(this.flow[i]);
          }
        }
        if (!dataExist) {
          const a = {
            id: k.id,
            order: k.order,
            organigram_name: k.organigram,
            flow_id: k.flow_id,
            is_delete: true,
            organigram_id: k.organigram_id,
          };
          finalObj.push(a);
        }
      });
      this.flow.forEach((data) => {
        if (typeof data.id === 'undefined') {
          // eslint-disable-next-line
          data.is_delete = false;
          // eslint-disable-next-line
          data.flow_id = this.detail_flow.id;
          finalObj.push(data);
        }
      });

      finalObj.forEach((data, index) => {
        if (typeof data.organigram_id === 'object') {
          finalObj[index].organigram_id = data.organigram_name.id;
        }
      });
      const sorterObj = finalObj.sort((a, b) => a.order - b.order);
      // members.push(...getData);
      // members.map((data) => {
      //   if (typeof data === 'object') {
      //     const dataMembers = {
      //       order: data.order,
      //       organigram_id: data.organigram_id,
      //       is_delete: false,
      //     }
      //     return dataMembers;
      //   }
      //   return data;
      // })
      // console.log(sorterObj);
      return sorterObj;
    },
    // open form add approver
    openAddApproverForm() {
      this.$refs.flowApprover.show();
      this.v_addApprover = {
        organigram_id: null,
        organigram_name: null,
        order: 1,
      };
      this.v_addDivision = {
        division: null,
        division_code: null,
        title: null,
        title_code: null,
        user: null,
      };
      this.$v.v_addApprover.$reset();
      this.$v.v_addDivision.$reset();
    },

    // clear selected approver input
    clearSelectedApprover() {
      this.v_addApprover.organigram_id = null;
      this.v_addApprover.organigram_name = null;
      this.v_addDivision.division = null;
      this.v_addDivision.division_code = null;
      this.v_addDivision.title = null;
      this.v_addDivision.title_code = null;
      this.v_addDivision.user = null;
    },

    // set approver in order
    setApprover() {
      if (this.selected === 'true') {
        this.$v.v_addApprover.$touch();
        if (!this.$v.v_addApprover.$error) {
          this.flow.push(this.add_approver);
          this.$refs.flowApprover.hide();
          this.clearSelectedApprover();
          this.v_addApprover.order += 1;
        }
      } else {
        this.$v.v_addDivision.$touch();
        if (!this.$v.v_addDivision.$error) {
          this.createDivisionInFlow(this.add_Division);
          this.$refs.flowApprover.hide();
          this.clearSelectedApprover();
        }
      }
    },

    // remove flow order
    removeFlow(data) {
      this.flow.splice(data, 1);
    },

    // edit selected flow
    editFlow(data) {
      this.edit_approver.status = true;
      this.edit_approver.current_edit = data;
      this.$refs.flowApprover.show();
      this.v_addApprover = this.flow[data];
      this.flow[data].organigram_name.label = this.flow[data].organigram_name.name ? this.flow[data].organigram_name.name : '-';
      this.oldEditData.push(this.add_approver);
      this.selected = 'true';
      this.getDetailPosition({ id: this.flow[data].organigram_id }).then((res) => {
        const dataDivision = res.data.divisions && res.data.divisions.length ?
          res.data.divisions[0] : null;
        if (dataDivision) {
          dataDivision.label = `${dataDivision.code} - ${dataDivision.name}`;
          this.v_addApprover.organigram_id = dataDivision;
        }
      });
    },

    // save new edit flow
    saveEditFlow() {
      this.$v.v_addApprover.$touch();
      if (!this.$v.v_addApprover.$error) {
        // console.log('failll');
        const currentEdit = this.edit_approver.current_edit;
        this.flow[currentEdit] = this.add_approver;
        this.$refs.flowApprover.hide();
        this.clearSelectedApprover();
        this.edit_approver.status = false;
        if (this.oldEditData[0]) {
          this.oldEditData.splice(0, 1);
        }
      }
    },

    // prevent reactivity
    closeEdit() {
      this.edit_approver.status = false;
      this.flow.splice(this.edit_approver.current_edit, 1, this.oldEditData[0]);
      this.$refs.flowApprover.hide();
      this.clearSelectedApprover();
      // this.oldEditData[0] = null;
      this.oldEditData.splice(0, 1);
    },

    // close add approver form and get default
    closeAddApprover() {
      this.$refs.flowApprover.hide();
      this.clearSelectedApprover();
      this.selected = 'true';
    },

    // save flows and create
    saveFlow() {
      this.$v.v_saveFlow.$touch();
      if (!this.$v.v_saveFlow.$error) {
        this.updateFlow(this.save_flow);
      }
    },

    loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'email',
          },
        };
        this.getListUsers(reqData, callback);
      }
    },

    async getListUsers(req, callback) {
      let apiUserData;

      if (req.pagination.query.length >= 3) {
        apiUserData = await apiUser.listUser(req);
      } else {
        apiUserData = [];
      }

      if (typeof apiUserData !== 'undefined') {
        apiUserData.forEach((lab, index) => {
          apiUserData[index].label = lab.email;
        });
      }
      callback(null, apiUserData);
      return apiUserData;
    },
  },
};
</script>

<style lang="scss">
// this style
.jFlow.flow-flex-center .save-flow-approver .b-form-group {
  padding-left: 0px;
}

.jFormGroup.form-control:disabled {
  cursor: not-allowed;
}

input.form-control::placeholder {
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/jFlowUpdate.vue